import gql from 'graphql-tag';

export const COPY_ITEM_MUTATION = gql`
  mutation CopyItem($targetLocation: LocationWhereUniqueInput!, $itemWhere: ItemWhereUniqueInput!) {
    duplicateItem(targetLocation: $targetLocation, item: $itemWhere) {
      id
    }
  }
`;
